export const isBoolean = (value: any) => typeof value === 'boolean';
